import type { RowPinnedType, Column } from 'ag-grid-community';

type RowPosition = {
  rowIndex: number;
  rowPinned: RowPinnedType;
};

type CellRange = {
  startRow: RowPosition;
  endRow: RowPosition;
  columns: Column[]; // actual AG Grid column type
};

function extractRangeInfo(ranges: CellRange[]) {
  if (!ranges.length) return null;

  let startRow = Number.MAX_SAFE_INTEGER;
  let endRow = Number.MIN_SAFE_INTEGER;
  let columns: Column[] = [];
  let maxColumnCount = -1;

  for (const range of ranges) {
    if (range.startRow.rowIndex < startRow) {
      startRow = range.startRow.rowIndex;
    }
    if (range.endRow.rowIndex > endRow) {
      endRow = range.endRow.rowIndex;
    }
    if (range.columns.length > maxColumnCount) {
      maxColumnCount = range.columns.length;
      columns = range.columns;
    }
  }

  return { startRow, endRow, columns };
}

export default extractRangeInfo;
